export enum MeasurementRange {
  DayInHours = 'DAY_IN_HOURS',
  WeekInDays = 'WEEK_IN_DAYS',
  MonthInDays = 'MONTH_IN_DAYS',
  YearInMonths = 'YEAR_IN_MONTHS',
  TenYearsInYears = 'TEN_YEARS_IN_YEARS',
}